<script>
    // https://svelte.dev/docs#createEventDispatcher
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    import Group from './Group.svelte';

    export let groups;

</script>

<style>
    .groups {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 8px;
    }
</style>

<div class="groups">
    {#each groups as group}
        <Group
            group={group}
            on:groupClicked="{(ev) => dispatch('changeGroup', ev.detail)}"
        />
    {:else}
    <p>loading...</p>
    {/each}
</div>
